import { useState } from 'react';

import { Information as InformationIcon } from '@mint-lib/icons';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  typographyVariants,
} from '@mint-lib/tw-components';

type Props = {
  label: string;
  infoText?: string;
};

const FieldLabel = ({ label, infoText }: Props) => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  const labelStyle = typographyVariants({
    variant: 'label01',
    color: 'secondary',
  });

  return (
    <div className="mb-1 flex flex-row gap-1" ref={setContainer}>
      <p className={labelStyle}>{label}</p>
      {infoText && (
        <Tooltip>
          <TooltipTrigger asChild>
            <InformationIcon
              aria-label="information-icon"
              className="fill-icon-secondary"
            />
          </TooltipTrigger>
          <TooltipContent side="top" align="center" container={container}>
            {infoText}
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
};

export { FieldLabel };
